import * as React from "react";
import * as ReactModal from "react-modal";
import {
    FEEDBACK_URL_BUG_REPORT,
    FEEDBACK_URL_FEATURE_REQUESTS,
    FEEDBACK_URL_GENERAL_FEEDBACK,
} from "../../../Constants";

interface FeedbackModalProps {
    onClose: () => void;
}

interface FeedbackTypeSelectionProps {
    text: string;
    uri: string;
    onClose: () => void;
}

export default function FeedbackModal(props: FeedbackModalProps) {
    const options = [
        ["Bug Report", FEEDBACK_URL_BUG_REPORT],
        ["Feature Request", FEEDBACK_URL_FEATURE_REQUESTS],
        ["General Feedback", FEEDBACK_URL_GENERAL_FEEDBACK],
    ];

    const modalContent: JSX.Element = (
        <div className="Feedback-container">
            <h2 className="Modal__header">Feedback to Installed Base team</h2>
            <table>
                <tbody>
                    {options.map((option, key) => (
                        <FeedbackTypeSelection
                            key={key}
                            text={option[0]}
                            uri={option[1]}
                            onClose={props.onClose}
                        />
                    ))}
                </tbody>
            </table>
            <div className="Modal__buttonGroup">
                <button className="btn btn-secondary" onClick={props.onClose}>
                    Cancel
                </button>
            </div>
        </div>
    );

    return (
        <ReactModal
            onRequestClose={props.onClose}
            isOpen={true}
            contentLabel="Modal"
            styles={{}}
            defaultStyles={{}}
        >
            {modalContent}
        </ReactModal>
    );
    // }
}

function FeedbackTypeSelection(props: FeedbackTypeSelectionProps) {
    const openFeedbackForm: Function = (uri) => {
        window.open(uri);
        props.onClose();
    };

    return (
        <tr>
            <td>
                <button
                    className="btn btn-primary Feedback-option"
                    onClick={() => openFeedbackForm(props.uri)}
                >
                    {props.text}
                </button>
            </td>
        </tr>
    );
}
